export default __webpack_public_path__ + "static/media/Trialmaster fight.ef250c78.png";